import { createIcon } from '@chakra-ui/react'

export const Prioritise = createIcon({
    displayName: 'Prioritise',
    viewBox: '0 0 8 14',
    d: 'M4 0L0 3.99H3V14H5V3.99H8L4 0ZM4 0L0 3.99H3V14H5V3.99H8L4 0Z',
})
